<template>
  <div class="input-bar-pills">
    <div class="input-bar-pill-container">
      <div
        v-for="choice in calculatedChoices"
        :key="choice.index"
        class="input-bar-pill td-200"
        v-text="choice.label"
      />
    </div>
    <div :style="{ height: inputBarHeight }" class="input-bar-pill-bar td-200" />
    <div class="input-bar-pill-text-container">
      <div
        v-for="choice in calculatedChoices"
        :key="choice.index"
        :class="[
          currentChoiceIndex === choice.index ? 'current' : '',
          currentChoiceIndex >= choice.index ? 'active' : '',
        ]"
        class="input-bar-pill td-200"
        @click="setSegmentIndex(choice.index)"
      >
        <markdown-text>{{ choice.label }}</markdown-text>
      </div>
    </div>
  </div>
</template>

<script>
import InputComponent from '../InputComponent';
import MarkdownText from '../../common/MarkdownText';

export default {
  name: 'InputBarPill',
  components: { MarkdownText },
  extends: InputComponent,
  props: {
    modelValue: {
      type: [String, Array],
      required: false,
      default: null,
    },
    choices: {
      type: Array,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      calculatedChoices: [],
      currentChoiceIndex: -1,
    };
  },
  computed: {
    reverse() {
      return true;
    },
    inputBarHeight() {
      let currentChoiceHeightPercent = 0;

      if (this.currentChoiceIndex >= 0 && this.calculatedChoices.length) {
        if (this.reverse) {
          currentChoiceHeightPercent = ((this.currentChoiceIndex + 1) / this.calculatedChoices.length) * 100;
        } else {
          currentChoiceHeightPercent = (((this.calculatedChoices.length - this.currentChoiceIndex)) / this.calculatedChoices.length) * 100;
        }
      }

      return `${currentChoiceHeightPercent}%`;
    },
  },
  watch: {
    modelValue() {
      this.setCurrentChoiceIndexFromModelValue();
    },
    choices() {
      this.recalculateChoices();
    },
  },
  mounted() {
    this.recalculateChoices();

    this.setCurrentChoiceIndexFromModelValue();
  },
  methods: {
    setCurrentChoiceIndexFromModelValue() {
      let index = 0;

      let { modelValue } = this;

      if (modelValue instanceof Array) {
        // eslint-disable-next-line prefer-destructuring
        modelValue = modelValue[0];
      }

      for (const choice of this.choices) {
        if (choice.value === modelValue) {
          this.currentChoiceIndex = index;

          break;
        }

        index += 1;
      }
    },
    recalculateChoices() {
      const calculatedChoices = [];

      if (this.reverse) {
        for (let i = this.choices.length - 1; i >= 0; i -= 1) {
          calculatedChoices.push({
            label: this.choices[i].label,
            value: this.choices[i].value,
            index: i,
          });
        }
      } else {
        for (let i = 0, len = this.choices.length; i < len; i += 1) {
          calculatedChoices.push({
            label: this.choices[i].label,
            value: this.choices[i].value,
            index: i,
          });
        }
      }

      this.calculatedChoices = calculatedChoices;
    },
    setSegmentIndex(n) {
      this.currentChoiceIndex = n;

      this.$emit('update:modelValue', this.choices[n].value);
    },
  },
};

</script>

<style lang="scss" scoped>
.input-bar-pills {
  position: relative;
  background-color: #BDC8CF;
  border-radius: 10px;
  width: 65px;
  margin: 0 auto;
  padding: 0;
  overflow: hidden;
  cursor: pointer;
}

.input-bar-pill-container {
  .input-bar-pill {
    color: transparent;
    background-color: #C7D3DA;
  }

  z-index: 1000;
  background-color: #BDC8CF;
}

.input-bar-pill-text-container, .input-bar-pill-container {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.input-bar-pill-text-container {
  position: relative;
}

.input-bar-pill-text-container {
  .input-bar-pill {
    transition-property: color, opacity;
    //transition-duration: 200ms;
    transition-timing-function: cubic-bezier(0.34, 1.56, 0.64, 1);
    z-index: 10000;
    color: #EDF1F4;
    line-height: 15px;

    &.active {
      color: #EDF1F4;
      opacity: 0.2;

      &.current {
        color: #FFFFFF;
        opacity: 1;
      }
    }
  }
}

.input-bar-pill {
  position: relative;
  height: 50px;
  width: 100%;
  text-align: center;
  font-weight: bold;
  line-height: 50px;
  margin-top: 3px;
  z-index: 1000000;

  &:first-child {
    margin-top: 0;
  }
}

.input-bar-pill-bar {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 0;
  z-index: 1000;

  transition-property: height;
  //transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.34, 1.56, 0.64, 1);

  background-color: #45A4CD;
}
</style>
<style lang="scss">
.input-bar-pill-text-container {
  .input-bar-pill {
    .markdown-text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      padding: 0 10px;
    }
  }
}
</style>
